
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"optix_billing_customer_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OptixBillingRestrictionOverridesInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingRestrictionsOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"optix_billing_customer_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"optix_billing_customer_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restriction_overrides"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location_cap"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user_cap"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_custom_unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_issues"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_products"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_tasks"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"perks"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"add_locations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"develop_apps"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"order_additional_onboarding_sessions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"order_optix_brand_removal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"order_white_labeled_mobile_app"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"send_push_notifications"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"use_announcements"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"use_properties"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":620}};
    doc.loc.source = {"body":"mutation ($optix_billing_customer_id: ID!, $input: OptixBillingRestrictionOverridesInput!) {\n  billingRestrictionsOverride(\n    optix_billing_customer_id: $optix_billing_customer_id\n    input: $input\n  ) {\n    restriction_overrides {\n      location_cap\n      user_cap\n\n      enable_custom_unit\n      enable_issues\n      enable_products\n      enable_tasks\n\n      events\n      perks\n\n      add_locations\n      develop_apps\n      order_additional_onboarding_sessions\n      order_optix_brand_removal\n      order_white_labeled_mobile_app\n      send_push_notifications\n      use_announcements\n      use_properties\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
